import { dateCompare1, isNullOrWhitespace, strCompareLowerCase } from "@common/Common";
import PortfolioOrDecisionNavigation from '@common/Components/PortfolioOrDecisionNavigation.vue';
import { guid } from "@common/Guid";
import { ICommandStatus } from "@cqrs/cqrs";
import CriteriaHierarchyQueries from "@Criteria/Hierarchies/Domain/queries-vue-component";
import { CriteriaHierarchyDependenciesReadModel } from "@Criteria/Hierarchies/Domain/readmodels";
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { EvalModelBuilderViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelBuilder";
import EvalModelBuilder from '@Evaluation/EvaluationModels/Components/EvalModelBuilder.vue';
import { EvalModelClonerViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelCloner";
import EvalModelCloner from '@Evaluation/EvaluationModels/Components/EvalModelCloner.vue';
import { EvalModelDeleterViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelDeleter";
import EvalModelDeleter from '@Evaluation/EvaluationModels/Components/EvalModelDeleter.vue';
import { EvalModelEditorViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelEditor";
import EvalModelEditor from '@Evaluation/EvaluationModels/Components/EvalModelEditor.vue';
import { CloneEvalModelCommandV1, CreateEvalModelCommandV1, DeleteEvalModelCommandV1, RenameGoalCommandV1 } from "@Evaluation/EvaluationModels/Domain/commands-core";
import EvalModelsCommands from "@Evaluation/EvaluationModels/Domain/commands-vue-component";
import EvalModelsQueries from "@Evaluation/EvaluationModels/Domain/queries-vue-component";
import { EvalModelReadModel, EvalModelsPageReadModel } from "@Evaluation/EvaluationModels/Domain/readmodels";
import moment from "moment";
import { Component, mixins } from 'vue-facing-decorator';
import { dynamicUiRoutes } from "@common/dynamicUiRoutes";


@Component({
    components: { PortfolioOrDecisionNavigation, EvalModelDeleter, EvalModelEditor, EvalModelBuilder, EvalModelCloner }
})
export default class EvalModelsPage extends mixins(EvalModelsQueries, EvalModelsCommands, CriteriaHierarchyQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId) }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId) }

    rm: EvalModelsPageReadModel | null = null;

    SearchPhrase: string = null;
    OrderBy: string = "created";
    OrderByDescending: boolean = true;
    evalModelDeleter = new EvalModelDeleterViewModel();
    evalModelEditor = new EvalModelEditorViewModel();
    evalModelBuilder = new EvalModelBuilderViewModel();
    evalModelCloner = new EvalModelClonerViewModel();

    get ProjectsView(): EvalModelReadModel[]
    {
        if (this.rm.Goals == null)
        {
            return null;
        }

        let view = new Array(...this.rm.Goals);

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            view = view.filter(o => o.Goal.toLowerCase().indexOf(this.SearchPhrase.toLowerCase()) >= 0);
        }

        if (this.OrderBy === "name")
        {
            view = view.sort((a, b) => strCompareLowerCase(a.Goal, b.Goal));
        }
        else if (this.OrderBy === "created")
        {
            view = view.sort((a, b) => dateCompare1(a.Created, b.Created));
        }

        if (this.OrderByDescending === true)
        {
            view = view.reverse();
        }

        return view;
    }

    formatDate(date: string | null)
    {
        if (date == null) return null;
        return moment(date).format('MMM D, YYYY')
    }

    formatTime(date: string | null)
    {
        if (date == null) return null;
        return moment(date).format('LT');
    }

    urlGoalRelativePath(evalModelId: number)
    {
        return dynamicUiRoutes.Criteria_CriteriaPage(this.$route, this.workspaceId, this.projectId, evalModelId);
    }


    showGoalCreator()
    {
        this.evalModelBuilder.show();
    }

    showGoalEditor(rm: EvalModelReadModel)
    {
        this.evalModelEditor.show(rm.EvalModelId, rm.Goal);
    }

    showGoalCloner(rm: EvalModelReadModel)
    {
        this.evalModelCloner.show(rm.EvalModelId, rm.Goal);
    }

    showGoalDeleter(rm: EvalModelReadModel)
    {
        this.evalModelDeleter.show(rm.EvalModelId, rm.Goal);
        this.runCriteriaHierarchyDependenciesQueryV1(this.workspaceId, rm.CriteriaHierarchyId);
    }


    OrderByNameCommand()
    {
        if (this.OrderBy === 'name')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = false;
            this.OrderBy = 'name';
        }
    }

    OrderByCreatedCommand()
    {
        if (this.OrderBy === 'created')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'created';
        }
    }

    handleCreateEvalModelCommand(goalName: string)
    {
        this.invokeCreateEvalModelCommandV1(this.workspaceId, this.projectId, goalName, `${guid()}.Default`);
    }

    handleRenameGoalCommand(evalModelId: number, goalName: string)
    {
        this.invokeRenameGoalCommandV1(this.workspaceId, evalModelId, goalName);
    }

    handleCloneEvalModelCommand(sourceId: number, cloneName: string)
    {
        this.invokeCloneEvalModelCommandV1(this.workspaceId, sourceId, cloneName, `${guid()}.Default`);
    }

    handleDeleteEvalModelCommand(evalModelId: number)
    {
        this.invokeDeleteEvalModelCommandV1(this.workspaceId, evalModelId);
    }


    mounted()
    {
        document.title = "Goals | TransparentChoice";
        this.runEvalModelsPageQueryV1(this.workspaceId, this.projectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "EvalModelsPageReadModel")
        {
            this.rm = model as EvalModelsPageReadModel;
        }
        else if (modelName === "EvalModelReadModel")
        {
            const rm = model as EvalModelReadModel;

            const curr = this.rm.Goals.find(a => a.EvalModelId === rm.EvalModelId);

            if (curr)
            {
                curr.Goal = rm.Goal;
            }
            else
            {
                this.rm.Goals.push(rm);
            }
        }
        else if (modelName === "CriteriaHierarchyDependenciesReadModel")
        {
            const rm = model as CriteriaHierarchyDependenciesReadModel;
            this.evalModelDeleter.setData(rm);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string, result: any)
    {
        if (CreateEvalModelCommandV1.matchType(cmd))
        {
            const evalModelId = Number(result);

            this.evalModelBuilder.close();
            window.location.href = this.urlGoalRelativePath(evalModelId);
        }
        else if (CloneEvalModelCommandV1.matchType(cmd))
        {
            const evalModelId = Number(result);
            this.runEvalModelByIdQueryV1(this.workspaceId, this.projectId, evalModelId);

            this.evalModelCloner.close();
        }
        else if (DeleteEvalModelCommandV1.matchType(cmd))
        {
            const evalModelId = Number.parseInt(correlationId);
            this.rm.Goals = this.rm.Goals.filter(a => a.EvalModelId !== evalModelId);

            this.evalModelDeleter.close();
        }
        else if (RenameGoalCommandV1.matchType(cmd))
        {
            const evalModelId = Number.parseInt(correlationId);
            this.runEvalModelByIdQueryV1(this.workspaceId, this.projectId, evalModelId);

            this.evalModelEditor.close();
        }

    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateEvalModelCommandV1.matchType(status.Command))
        {
            this.evalModelBuilder.displayValidationErrors(status.ValidationErrors);            
        }
        else if (RenameGoalCommandV1.matchType(status.Command))
        {
            this.evalModelEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (CloneEvalModelCommandV1.matchType(status.Command))
        {
            this.evalModelCloner.displayValidationErrors(status.ValidationErrors);
        }
    }
}
